import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box } from "@mui/material";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import EditHeader from "./EditHeader";
import FormSection from "./FormSection";
import { useDispatch } from "react-redux";
import { getCartEditPreData } from "../../../../../redux/features/cartSlice";
import { EditButton } from "../../../../../components/mui/Buttons/Buttons";

const CartItemEdit = React.memo(({ row, dispatchParams }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const profile = JSON.parse(localStorage.getItem("cred")).profile;

  useEffect(() => {
    if (open) {
      const data = {
        reqId: row.request_id || "",
        enrollId: row.course_enrollment_id || row?.courseEnrollmentId,
      };
      dispatch(getCartEditPreData(data));
    }
  }, [open]);
  return (
    <GlobalDialog
      title={"Cart Edit"}
      open={open}
      setOpen={setOpen}
      fullScreen
      closeButton={true}
      popupButton={
        <EditButton
          disabled={
            (row.approvals?.length > 0 &&
              row.approvals[0].request_approval_by !== profile.userId) ||
            row?.isDisableCartEdit === 0 ||
            row?.isEnableEdit === 0 ||
            (row.approvals?.length > 0 &&
              row.approvals[0].approvalStatus !== "Pending")
          }
          size="small"
          action={() => setOpen(true)}
        />
      }
      content={
        <>
          {open && (
            <GlobalWrapper>
              <Box>
                <EditHeader />
              </Box>
              <Box sx={{ p: 3 }}>
                <FormSection
                  dispatchParams={dispatchParams}
                  setOpen={setOpen}
                  params={{
                    reqId: row.request_id || "",
                    enrollId:
                      row.course_enrollment_id || row.courseEnrollmentId || "",
                  }}
                />
              </Box>
            </GlobalWrapper>
          )}
        </>
      }
    />
  );
});

export default CartItemEdit;
